<template>
  <div>
    <!-- <b-container fluid class="px-0">
      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="4000"
        fade
        controls
        indicators
        background="#ababab"
        img-width="1024"
        img-height="480"
        style="text-shadow: 1px 1px 2px #333"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide img-src="https://picsum.photos/1024/480/?image=1">
          <div class="text-left">
            <h5>Processo sísmico 1</h5>
          </div>
        </b-carousel-slide>

        <b-carousel-slide img-src="https://picsum.photos/1024/480/?image=58">
          <div>
            <h5>Processo sísmico 2</h5>
          </div>
        </b-carousel-slide>

        <b-carousel-slide>
          <template v-slot:img>
            <img
              class="d-block img-fluid w-100"
              width="1024"
              height="480"
              src="https://picsum.photos/1024/480/?image=10"
              alt="image slot"
            />
          </template>
        </b-carousel-slide>
      </b-carousel>
    </b-container> -->
    <!-- SERVICOS -->
    <!-- BACIAS EM QUE TRABALHAMOS -->
    <b-container fluid style="background-color: #fff59d">
      <b-container class="py-5">
        <div class="about-low-area">
          <div class="container">
            <div class="row justify-content-between">
              <div class="col-xl-6 col-lg-6 col-md-10">
                <div class="about-caption mb-50">
                  <!-- Section Tittle -->
                  <div class="section-tittle mb-35">
                    <h1>Conheça o CPGeo</h1>
                  </div>
                  <p class="text-justify">
                    O Centro Potiguar de Geociências - CPGeo é uma empresa
                    brasileira de geofísica especializada em processamento de
                    dados sísmicos terrestre e marítimo, 2D e 3D, PSTM, PSDM e
                    CRS com praticamente 100% de conteúdo local. Localizado em
                    Natal/RN, é composto por geocientistas com larga experiência
                    no ramo de petróleo, e também responsáveis pelo
                    desenvolvimento de grande parte do portfólio de software da
                    empresa Possuímos cadastro na ONIP como Fornecedora
                    Qualificada da Indústria do Petróleo e na ANP como
                    fornecedora do serviço de Processamento de dado sísmico 2D e
                    3D, possuindo também a certificação de conteúdo local de
                    93% para estes serviços.
                  </p>
                </div>
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                    <div class="experience">
                      <span>120.000 km</span>
                      <p>Processamento 2D</p>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                    <div class="experience">
                      <span>6.400 km²</span>
                      <p>Processamento 3D</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-5 col-lg-6 col-md-9 offset-md-1 offset-sm-1">
                <div class="about-right-cap">
                  <div class="about-right-img">
                    <img src="@/assets/home/bacias.png" class="img-fluid" alt />
                  </div>
                  <div class="img-cap">
                    <span>+35</span>
                    <p>Anos de experiência</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-5"></div>
        <b-row cols="1" cols-md="2">
          <b-col>
            <b-img fluid src="@/assets/home/sismica_2d_bacias.png"></b-img>
          </b-col>
          <b-col>
            <b-img fluid src="@/assets/home/sismica_3d_bacias.png"></b-img>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
    <b-container fluid>
      <Servicos />
    </b-container>
  </div>
</template>

<script>
import Servicos from "@/components/home/Servicos";

export default {
  name: "Home",
  components: {
    Servicos,
  },
};
</script>

<style>
.about-low-area {
  position: relative;
}

.about-low-area .about-caption p {
  font-size: 16px;
  color: #64676c;
  line-height: 1.6;
  margin-bottom: 58px;
  padding-right: 50px;
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-low-area .about-caption p {
    padding-right: 20px;
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .about-low-area .about-caption p {
    padding-right: 0px;
  }
}

@media (max-width: 575px) {
  .about-low-area .about-caption p {
    padding-right: 0px;
  }
}

.about-low-area .experience span {
  color: #fbc02d;
  font-size: 38px;
  font-weight: 500;
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-low-area .experience span {
    font-size: 42px;
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .about-low-area .experience span {
    font-size: 45px;
  }
}

@media (max-width: 575px) {
  .about-low-area .experience span {
    font-size: 45px;
  }
}

.about-low-area .about-right-cap {
  position: relative;
}

@media (max-width: 575px) {
  .about-low-area .about-right-cap {
    padding-top: 50px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-low-area .about-right-cap {
    padding-top: 50px;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-low-area .about-right-cap {
    padding-top: 50px;
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .about-low-area .about-right-cap {
    padding-top: 50px;
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .about-low-area .about-right-cap {
    padding-top: 50px;
  }
}

.about-low-area .about-right-cap .about-right-img img {
  width: 100%;
  margin-bottom: 15px;
}

.about-low-area .about-right-cap .img-cap {
  position: absolute;
  bottom: -7px;
  left: -33px;
  width: 179px;
  height: 180px;
  padding: 31px 10px;
  background: #ffd600;
  text-align: center;
}

@media (max-width: 575px) {
  .about-low-area .about-right-cap .img-cap {
    left: 0;
    width: 128px;
    height: 145px;
    padding: 8px 10px;
  }
}

.about-low-area .about-right-cap .img-cap span {
  font-size: 50px;
}

.about-low-area .about-right-cap .img-cap p {
  font-size: 15px;
}

.about-low-area .about-right-cap p {
  font-size: 22px;
  color: #140c40;
  font-weight: 300;
  padding-right: 13px;
  line-height: 1.5;
}

.about-low-area .about-right-cap .about-right-cap2 {
  margin-bottom: 0px;
}

@media (max-width: 575px) {
  .about-low-area .about-right-cap .about-right-cap2 {
    margin-bottom: 0px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-low-area .about-right-cap .about-right-cap2 {
    margin-bottom: 0px;
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .about-low-area .about-right-cap .about-right-cap2 {
    margin-bottom: 0px;
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .about-low-area .about-right-cap .about-right-cap2 {
    margin-bottom: 0px;
  }
}

@media (max-width: 575px) {
  .about-caption {
    margin-bottom: 35px;
  }
}
</style>
